import React from 'react'

export default function WeCreate() {
  return (
    <div className='contentbox'>
        <img width='704.816px' height='507px' className='imageOnRight' src='/img/1.png' alt='Sending rocket to space' />
        <h1>We Create<br />Startups.</h1>
        <h5>We are startup studio that develops and launches new companies.</h5>
        <a className='button' href='#ourworks'><span>See our works</span></a>
    </div>
  )
}
